var map = {
	"./character_leaderboards.png": "c8d0",
	"./community_lobby.png": "09bc",
	"./community_map_packs.png": "1add",
	"./dustkid_daily.png": "3321",
	"./extensive_configuration.png": "12d9",
	"./input_display.png": "2c3a",
	"./online_multiplayer.png": "9cc0",
	"./replay_ghosts.png": "995d",
	"./save_recovery_reset.png": "a040",
	"./tas_leaderboards.png": "4bfc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05c8";